<script lang="ts">
  import { onMount, type Snippet } from "svelte";
  import { setupConvex, setupAuth } from "convex-svelte";
  import { CONVEX_URL } from "$lib/env";
  import { auth } from "$lib/auth.svelte";
  import { theme } from "$lib/theme.svelte";
  import "../app.css";

  let { children }: { children: Snippet } = $props();

  setupConvex(CONVEX_URL);
  setupAuth(() => ({
    isLoading: auth.isLoading,
    isAuthenticated: auth.isAuthenticated,
    fetchAccessToken: (args) => auth.fetchAccessToken(args),
  }));

  onMount(() => {
    theme.init();
    void auth.init();
  });
</script>

{@render children()}
